function PageButton({ active, disabled, children, onClick }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={[
        "inline-flex items-center justify-center rounded-md px-3 py-2 text-sm",
        active
          ? "bg-[#d24a17] text-white"
          : "bg-white text-[#263238] hover:bg-[#f3f4f6] border border-[#e5e7eb]",
        disabled && "!cursor-not-allowed opacity-50",
      ].join(" ")}
    >
      {children}
    </button>
  );
}

/** Compact numbered pagination with Prev/Next + ellipses */
export default function Pagination({ page, totalPages, onChange }) {
  if (totalPages <= 1) return null;

  const go = (p) => onChange(Math.min(totalPages, Math.max(1, p)));

  const nums = buildRange(page, totalPages);

  return (
    <nav className="flex items-center justify-center gap-2">
      <PageButton disabled={page === 1} onClick={() => go(page - 1)}>
        Prev
      </PageButton>

      {nums.map((n, i) =>
        n === "…" ? (
          <span key={`dots-${i}`} className="px-2 text-[#6b7280]">…</span>
        ) : (
          <PageButton
            key={n}
            active={n === page}
            onClick={() => go(n)}
          >
            {n}
          </PageButton>
        )
      )}

      <PageButton disabled={page === totalPages} onClick={() => go(page + 1)}>
        Next
      </PageButton>
    </nav>
  );
}

/** show up to 7 buttons: 1 … p-1 p p+1 … last */
function buildRange(page, total) {
  const pages = [];
  const push = (v) => pages.push(v);

  if (total <= 7) {
    for (let i = 1; i <= total; i++) push(i);
    return pages;
  }

  const first = 1, last = total;
  const left = Math.max(2, page - 1);
  const right = Math.min(total - 1, page + 1);

  push(first);
  if (left > 2) push("…");
  for (let i = left; i <= right; i++) push(i);
  if (right < total - 1) push("…");
  push(last);

  return pages;
}
